<template>
  <el-dialog
    title="更换付款账户"
    :visible.sync="visible"
    width="380px"
    @open="handleOpen"
  >
    <el-form
      ref="payAccountFormRef"
      v-loading="loading"
      :model="formData"
      label-width="80px"
    >
      <el-form-item
        prop="accountId"
        label="付款账户"
        :rules="[
          { required: true, message: '请选择付款账户', trigger: 'change' },
        ]"
      >
        <el-select
          v-model="formData.accountId"
          clearable
          filterable
          placeholder="请选择"
          class="resetopions"
        >
          <el-option
            v-for="item in subAccountOptions"
            :key="item.accountId"
            :label="item.merchantName"
            :value="item.accountId"
          >
            <div class="selectPlan-item">
              <TextOverTooltip :content="item.merchantName" placement="top" />
              <TextOverTooltip :content="item.bankCardNo" placement="top" />
              <TextOverTooltip :content="item.bankShortName" placement="top" />
            </div>
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div>
      注意：此次修改仅针对 「<span style="color: red">新订单</span>」生效
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="hanleCancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="btnLoading"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script setup>
import { ref } from 'vue'
import { getSubAccountList, updatePayAccount } from '@/api/domain/finance'

const visible = ref(false)
const loading = ref(false)
const payAccountFormRef = ref(null)
const btnLoading = ref(false)
const formData = ref({
  accountId: '',
})
const initData = ref(null)
const subAccountOptions = ref([])

const emits = defineEmits(['refresh'])

const getOptions = () => {
  loading.value = true
  getSubAccountList({
    accountType: 2,
    channelType: 6,
    pageNum: 1,
    openState: 3,
    state: 1,
    pageSize: 1000,
  })
    .then((res) => {
      const { code, data } = res
      if (code !== 1) return
      subAccountOptions.value = data?.items || []
    })
    .finally(() => {
      loading.value = false
    })
}

const handleOpen = () => {
  getOptions()
}

const openDialog = (row) => {
  initData.value = row
  formData.value = { accountId: row.accountId }
  visible.value = true
}

const closeDialog = () => {
  initData.value = null
  formData.value = { accountId: '' }
  visible.value = false
}

const handleSubmit = () => {
  if (btnLoading.value) return
  payAccountFormRef.value.validate((valid) => {
    if (!valid) return
    btnLoading.value = true
    updatePayAccount({
      id: initData.value.id,
      accountId: formData.value.accountId,
    })
      .then(({ code, data }) => {
        if (code === 1 && data) {
          emits('refresh')
          closeDialog()
        }
      })
      .finally(() => {
        btnLoading.value = false
      })
  })
}

const hanleCancel = () => {
  closeDialog()
}

defineExpose({
  open: openDialog,
  close: closeDialog,
})
</script>

<style lang="scss" scoped>
::v-deep(.el-clamp-lines__alone) {
  overflow: visible;
  display: inline-block;
}
.selectPlan-item {
  height: auto;
  width: 150px !important;
}
.resetopions {
  height: auto;
}
.el-select-dropdown__item {
  height: auto;
}
</style>
